import { render, staticRenderFns } from "./TileOoe.vue?vue&type=template&id=f22713b0"
import script from "./TileOoe.vue?vue&type=script&lang=js"
export * from "./TileOoe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports